import React from 'react';
import styles from './Projects.module.css';


const Projects = () => {
    return (
        <div className={styles.projectsPage}>
            {/* Hero Section */}
            <section className={styles.heroSection}>
                <div className={styles.container}>
                    <div className={styles.heroContent}>
                        <div className={styles.titleSection}>
                            <h1 className={styles.mainTitle}>
                                <span className={styles.titleDark}>Key</span>{' '}
                                <span className={styles.titleBlue}>Projects</span>
                            </h1>
                            <p className={styles.subtitle}>
                                Our recent projects exemplify a paradigm shift in innovation and execution, redefining 
                                success with their flawless implementation.
                            </p>
                        </div>
                        
                        {/* Geometric Design Elements */}
                        {/* <div className={styles.geometricElements}>
                            <div className={styles.blueTriangle}></div>
                            <div className={styles.greenCircle}></div>
                        </div> */}
                    </div>
                </div>
                
                {/* Background Image */}
                
            </section>
            
            {/* Successful Projects Section */}
            
            {/* Featured Projects Carousel */}
            
            
            {/* Projects Grid Section */}
            <section className={styles.projectsGridSection}>
                <div className={styles.container}>
                    <div className={styles.projectsGrid}>
                        {projectsData.map((project, index) => (
                            <div key={index} className={styles.projectCard}>
                                <div className={styles.projectImageContainer}>
                                    <img 
                                        src={project.image} 
                                        alt={project.title}
                                        className={styles.projectImage}
                                    />
                                    
                                </div>
                                <div className={styles.projectInfo}>
                                    <h3 className={styles.projectCardTitle}>{project.title}</h3>
                                    <p className={styles.projectSubtitle}>{project.subtitle}</p>
                                </div>
                                {/* <div className={styles.projectArrow}>
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                            <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    </div> */}
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

// Projects data
const projectsData = [
    {
        title: "Supply, Design, Engineering & Installation of 400/220/132/33kV",
        subtitle: "GIS Substation at Sector–148, Noida.",
        image: "/images/substation.jpg"
    },
    {
        title: "Supply, Design, Engineering & Installation of 400/132/33kV",
        subtitle: "GIS Substation at Sector– 123,Noida",
        image: "/images/substation2.jpg"
    },
    {
        title: "Supply of 132kV Underground Cable Installation at Allahabad",
        subtitle: "From GIS Power house S/S to 220kV Cant. S/S",
        image: "/images/substation3.jpg"
    },
    {
        title: "Supply and Erection for 132kV 2-Phase underground XLPE cable",
        subtitle: "Along with 400mm² Aluminum conductor Ramsanehi Ghat – Budhwal TSS Transmission Line",
        image: "/images/substation4.jpg"
    },
    {
        title: "E&M works for Railways Tunnels (T-40 to T-47)",
        subtitle: "For Tunnel T-40/41, T-42/43,T-44/45,T-46 & T/47 in Katra– Dharam section of Udhampur–Srinagar- Baramulla rail link project",
        image: "/images/railwaytunnel.jpg"
    },
    {
        title: "E&M works for Railway Tunnels (T-6 to T-12)",
        subtitle: "For Tunnel T-6, T-9,T-10,T-11 &T-12 in Katra– Dharam section of Udhampur– Srinagar- Baramullarail link project",
        image: "/images/railwaytunnel2.jpg"
    },
    {
        title: "Supply of 132kV Single Core 630 sq. mm Aluminum Conductor Corrugated XLPE cable",
        subtitle: "For 132kV DC FCI- Bhathat Cable Line Gorakhpur",
        image: "/images/substation7.jpg"
    },
    {
        title: "Supply and Erection of 1 Nos of 132kV Hybrid Switchgear Bay Installation",
        subtitle: "For bus coupler at 220/132/33kV Substation, Sec-62, Noida",
        image: "/images/substation8.jpg"
    }
];

export default Projects;
